import {API} from "../http";
import {NEW_ENDPOINTS} from "../http/endpoints";
import {message} from "antd";

export const fetchUsers = async () => {
  try {
    const { data: { rr: users } } = await API.post(NEW_ENDPOINTS.ADMIN.USER.GET_LIST);
    return users;
  } catch (e) {
    message.error('Failed to load users list');
  }
};
export const fetchTariffs = async () => {
  try {
    const {data} = await API.get(NEW_ENDPOINTS.ADMIN.TARIFFS, {
      headers: {
        token: 'my1perfect2token',
      }
    });
    return data;
  } catch (e) {
    message.error('Error fetching tariffs list');
  }
}

export const generateSumSubLink = async (userId) => {
  if (userId) {
    try {
      const { data: { link: { url } } } = await API.post(NEW_ENDPOINTS.ADMIN.USER.GET_SUMSUB_LINK, {
        external_id: userId,
      });
      console.log({url})
      setTimeout(() => {
        navigator.clipboard.writeText(url)
      }, 0)
      message.success('Copied to clipboard');
      return url;
    } catch (e) {
      message.error('Error generating link for verification');
      throw e;
    }
  }
}
